import { Component, OnInit } from '@angular/core';
import { SeoSocialShareService, SeoSocialShareData } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit {

  seoData: SeoSocialShareData = {
    title:  'Privacy Policy',
    description: 'Because we value your patronage, we want to address any privacy concerns you may have. To that end, we have set forth our privacy policy for handling the information you share with us online. We want your decision to do business with us to be an informed one.',
    image: environment.url+'/assets/logo.png'
  };

  constructor( private seo: SeoSocialShareService) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
  }

}
